module.exports = __webpack_public_path__ + "static/media/hand-rock.222e5191.svg";